import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import "../Styles/CardTorneo.css"; // Asegúrate de que esta ruta sea correcta
import { AgregarCardBoton } from "../../AddCard/Components/AddComponent";
import { useNavigate } from "react-router-dom";
import trofeo1 from "../../../assets/trofeo1.jpg";
import { BASE_URL } from "../../../config";
import deportistas1 from "../../../assets/deportistas1.jpg";

import axios from "axios";
import CarouselComponent from "./CarouselImagesComponent";

const DashboardLogout = () => {
  const navigate = useNavigate();
  const [cargando, setCargando] = useState(true);
  const [albumImages, setAlbumImages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [torneos, setTorneos] = useState([]);
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchTorneos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}torneos`);
        setTorneos(response.data);
      } catch (error) {
        console.error("Error fetching torneos:", error);
      } finally {
        setCargando(false);
      }
    };
    fetchTorneos();
  }, []);

  const fetchAlbumImages = async () => {
    try {
      const response = await fetch(`${BASE_URL}images`);
      const data = await response.json();
      setAlbumImages(data);
    } catch (error) {
      console.error('Error al obtener las imágenes:', error);
    }
  };

  useEffect(() => {
    fetchAlbumImages();
  }, []);

  const filteredTorneos = torneos.filter(
    (torneo) =>
      torneo.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      torneo.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleNavigateToEstadisticas = (torneo) => {
    const nombreEncoded = encodeURIComponent(torneo.nombre);
    navigate(`/estadisticas/${torneo.id}/${nombreEncoded}`);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleNavigateToEquipos = (torneo) => {
    navigate(`/partidoslogout/${torneo.id}`);
  };

  const displayTorneos = filteredTorneos
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
    .map((torneo) => (
      <div
        key={torneo.id}
        className="torneo-card"
        onClick={() => handleNavigateToEquipos(torneo)}
      >
        <img src={deportistas1} alt={torneo.nombre} className="image" />
        <h3 className="torneo-title">{torneo.nombre}</h3>
        <p className="torneo-text">
          Disciplina: {torneo.configuracion_torneo.disciplina.nombreDisciplina}
        </p>
        <div className="button-container-torneo">
      
      
        </div>
        <button
          className="action-butto-conta"
          onClick={(e) => {
            e.stopPropagation();
            handleNavigateToEstadisticas(torneo);
          }}
        >
          <i className="fas fa-chart-bar"></i> Estadísticas Torneo
        </button>
      </div>
    ));

  return (
    <div className="torneo-container">
    <CarouselComponent images={albumImages} />
      <div className="card-container-torneo">
        {/* <div className="background-div">
          <AgregarCardBoton image={trofeo1} />
        </div> */}
        {displayTorneos}
      </div>
      <ReactPaginate
        pageCount={Math.ceil(filteredTorneos.length / itemsPerPage)}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
        previousLabel={"< Anterior"}
        nextLabel={"Siguiente >"}
      />
    </div>
  );
};
export {DashboardLogout};
